var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('superset-skeleton'):_c('superset',{attrs:{"superset":_vm.currentSuperset,"is-today":_vm.myProgram},scopedSlots:_vm._u([{key:"exercise",fn:function(){return [_c('router-view',{on:{"exercise-changed":_vm.fetchSuperset}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }